import { SkyDialog, SkyText } from "@skypointcloud/skypoint-ui";
import ClockImage from "../icons/ClockImage";

interface ISessionTimeoutDialogFluent {
  open: boolean;
  countdown: number;
  onLogout: () => void;
  onContinue: () => void;
}

export const SessionTimeoutDialogFluent = (props: ISessionTimeoutDialogFluent) => {
  const { open, countdown, onLogout, onContinue } = props;

  const dialogDescription = (
    <div className="flex flex-col gap-6 p-0">
      {/* Timer Widget */}
      <div className="flex flex-row items-center justify-center gap-2">
        <div className="w-[30px] h-[30px] flex items-center">
          <ClockImage />
        </div>
        <div className="flex flex-row items-baseline gap-0.5">
          <span
            key={countdown}
            className="text-fg-danger-soft text-[28px] font-medium"
          >
            {countdown}
          </span>
          <SkyText className="text-base">sec</SkyText>
        </div>
      </div>

      {/* Session Text */}
      <SkyText className="text-center text-sm leading-normal">
        The current session is about to expire. Would you like to continue the session?
      </SkyText>
    </div>
  );

  return (
    <SkyDialog
      open={open}
      onOpenChange={() => {
        // Dialog close is controlled by action buttons only
      }}
      title="Session timeout"
      description={dialogDescription}
      size="sm"
      primaryAction={{
        label: "Continue",
        onClick: onContinue,
      }}
      secondaryAction={{
        label: "Logout",
        onClick: onLogout,
      }}
    />
  );
};
